"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lazy = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var lazy = function lazy(loader) {
  return new Proxy({}, {
    get: function get(target, componentName) {
      return /*#__PURE__*/_react.default.lazy(function () {
        return loader().then(function (x) {
          return {
            default: x[componentName]
          };
        });
      });
    }
  });
};
exports.lazy = lazy;